import React from 'react';
import type { Dispatch, SetStateAction } from 'react';

import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { SidebarTab } from 'Components/CanvasEditor/types';

interface TabCardProps {
  tab: SidebarTab;
  isActiveTab: boolean;
  onTabChange: Dispatch<SetStateAction<string>>;
}

export default function TabCard({ tab, isActiveTab, onTabChange }: TabCardProps) {
  const onTabClick = (tab: SidebarTab['id']) => () => onTabChange(tab);

  return (
    <button
      onClick={onTabClick(tab.id)}
      className={classnames('tab-item', isActiveTab && 'tab-item-active')}
    >
      <span className="tab-item-icon">
        <FontAwesomeIcon icon={tab.icon} style={{ fontSize: 16 }} />
      </span>
    </button>
  );
}
